import React from 'react';
import { Navigate, useLocation } from 'react-router-dom'; 
import { useAuth } from '../context/UserContext'; 
import { Spin } from 'antd'; 
// Import Auth để kiểm tra trạng thái ngay lập tức
 

function ProtectedRoute({ children }) {
  
  const { userData, loading } = useAuth(); 
  const location = useLocation();

  if (loading) {
    return <Spin tip="Đang khôi phục phiên đăng nhập…" size="large" style={{ display: 'block', margin: '50px auto' }} />;
  }

  // --- TRẠNG THÁI 3: KHÔNG ĐĂNG NHẬP ---
  // Lưu lại đường dẫn (kèm query string) người dùng ĐANG ĐỊNH VÀO, để sau khi
  // đăng nhập xong quay lại đúng chỗ đó — thay vì luôn về trang chủ. Nhờ vậy,
  // 1 link được copy/gửi cho học sinh vẫn dẫn đúng tới nội dung sau khi đăng nhập.
  if (userData === null) {
    const fullPath = location.pathname + location.search;
    return <Navigate to="/login" state={{ from: fullPath }} replace />; 
  }

  // --- TRẠNG THÁI 4: ĐÃ ĐĂNG NHẬP ---
  return children;
}

export default ProtectedRoute;